export default __webpack_public_path__ + "static/media/shop-mobile.38fb94c8.jpeg";